// #region imports

// --- Angular
import {
  Input,
  EventEmitter,
  Output,
  ElementRef,
  AfterViewInit,
  OnDestroy,
  Component,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

// --- RxJs
import { fromEvent, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

// --- 3rd party
import { User } from 'oidc-client';

// --- HS Code
import { LanguageModel } from '../../models';
import { Utils } from '../../shared';

// #endregion

@Component({ template: '' })
export abstract class NavBarBaseComponent implements AfterViewInit, OnDestroy {
  @Input() isLoading: boolean | null = false;
  @Input() identity: User | null = null;
  @Input() languages: LanguageModel[] | null = null;
  @Input() selectedLanguage: LanguageModel | null = null;
  @Input() isMobileUser: boolean = false;

  @Output() login = new EventEmitter();
  @Output() logout = new EventEmitter();
  @Output() languageChanged = new EventEmitter<LanguageModel>();

  private _scrollEventSubscription: Subscription = Subscription.EMPTY;
  protected givenName: string = '';

  constructor(private elementRef: ElementRef) { }

  ngAfterViewInit(): void {
    this._scrollEventSubscription = fromEvent(window, 'scroll')
      .pipe(debounceTime(100))
      .subscribe(this._onWindowScroll.bind(this));
  }

  ngOnDestroy(): void {
    if (this._scrollEventSubscription) {
      this._scrollEventSubscription.unsubscribe();
      this._scrollEventSubscription = Subscription.EMPTY;
    }
  }

  onLogin(): void {
    if (this.isLoading) {
      return;
    }

    this.login.emit();
  }

  signoutRedirect() {
    if (this.isLoading) {
      return;
    }

    this.logout.emit();
  }

  checkActive(e: any): void {
    if (this.isLoading) {
      e.preventDefault();
    }
  }

  onLanguageChanged(newLanguage: LanguageModel): void {
    this.languageChanged.emit(newLanguage);
  }

  private _onWindowScroll(event: Event) {
    /*
    if (window.scrollY > 1) {
      this.elementRef.nativeElement.classList.add('sticky');
      if (
        this.elementRef.nativeElement &&
        this.elementRef.nativeElement.parentElement &&
        this.elementRef.nativeElement.parentElement.nextElementSibling
      ) {
        const container =
          this.elementRef.nativeElement.parentElement.nextElementSibling.querySelector(
            '.questions-container'
          );
        if (container) {
          container.classList.add('gooey');
        }
      }
    } else {
      this.elementRef.nativeElement.classList.remove('sticky');
      if (
        this.elementRef.nativeElement &&
        this.elementRef.nativeElement.parentElement &&
        this.elementRef.nativeElement.parentElement.nextElementSibling
      ) {
        const container =
          this.elementRef.nativeElement.parentElement.nextElementSibling.querySelector(
            '.questions-container'
          );
        if (container) {
          container.classList.remove('gooey');
        }
      }
    }*/
  }
}
